<template>
  <div
    class="totem"
    :style="{paddingTop: fullScreen ? 0 : isInverted ? '73px' : '680px', zoom: zoomValue}"
  >
    <messages
      v-if="fullScreen && mainEnterprise"
      :enterprise="mainEnterprise"
    />
    <screen-saver v-if="fullScreen"/>

    <!--totem-header
      v-if="fullScreen && mainEnterprise"
      :enterprise="mainEnterprise"
      :locale="locale"
      :onlyBar="isInverted"
    /-->
    <header-bar
      v-if="fullScreen && mainEnterprise"
      :enterprise="mainEnterprise"
      :locale="locale"
      :noShadow="mainEnterprise ? mainEnterprise.TotemNoShadow : false"
    />
    <parrilla
      v-if="fullScreen && mainEnterprise && !isInverted"
      :parrilla="mainEnterprise.Parrilla"
    />
    <TotemMainMenu
      v-if="!isInverted"
      :enterprise="mainEnterprise"
      :locale="locale"
      :noShadow="mainEnterprise ? mainEnterprise.TotemNoShadow : false"
    />
    <div
      class="totem-body"
      :style="{ height: isInverted ? '980px !important' : null }"
    >
      <interactive-map
        v-if="$store.state.app.totemActiveMenuItem && $store.state.app.totemActiveMenuItem.type === 'interactiveMap'"
        :item="$store.state.app.totemActiveMenuItem"
        :locale="locale"
      />
      <activity-college
          v-else-if="totemActiveMenu && totemActiveMenu === ':activityCollege'"
          :enterprise="mainEnterprise"
      />
      <activity-barcelo
        v-else-if="totemActiveMenu && totemActiveMenu.indexOf(':activityBarcelo') >= 0"
        :enterprise="mainEnterprise"
        :locale="locale"
        :dviewDviewcontentID="totemActiveMenu.split('activityBarcelo').pop()"
      />
      <Activity
        v-else-if="totemActiveMenu && totemActiveMenu.indexOf(':activity') >= 0"
        :enterprise="mainEnterprise"
      />
      <Meteo
        v-else-if="totemActiveMenu === ':meteo'"
        :enterprise="mainEnterprise"
      />
      <Aena
        v-else-if="totemActiveMenu === ':aena'"
        :locale="locale"
        :enterprise="mainEnterprise"
      />
      <Aena
        v-else-if="totemActiveMenu === ':aenaLanzarote'"
        :isLanzarote="true"
        :locale="locale"
        :enterprise="mainEnterprise"
      />
      <Aena
        v-else-if="totemActiveMenu === ':aenaFuerteventura'"
        :isFuerteventura="true"
        :locale="locale"
        :enterprise="mainEnterprise"
      />
      <Aena
        v-else-if="totemActiveMenu === ':aenaGranCanaria'"
        :isGranCanaria="true"
        :locale="locale"
        :enterprise="mainEnterprise"
      />
      <Aena
        v-else-if="totemActiveMenu === ':aenaPalmaDeMallorca'"
        :isPalmaDeMallorca="true"
        :locale="locale"
        :enterprise="mainEnterprise"
      />
      <Aena
        v-else-if="totemActiveMenu === ':aenaIbiza'"
        :isIbiza="true"
        :locale="locale"
        :enterprise="mainEnterprise"
      />
      <Aena
        v-else-if="totemActiveMenu === ':aenaMenorca'"
        :isMenorca="true"
        :locale="locale"
        :enterprise="mainEnterprise"
      />
      <Aena
        v-else-if="totemActiveMenu === ':aenaMalaga'"
        :isMalaga="true"
        :locale="locale"
        :enterprise="mainEnterprise"
      />
      <airport-praia
        v-else-if="totemActiveMenu === ':airportPraia'"
        :locale="locale"
        :enterprise="mainEnterprise"
      />
      <item-image
        v-else-if="totemActiveMenu === ':image'"
      />
      <item-image-translate
        v-else-if="totemActiveMenu === ':imageTranslate'"
      />
      <item-pdf
        v-else-if="totemActiveMenu && totemActiveMenu.indexOf('pdf') >= 0"
        :enterprise="mainEnterprise"
      />
      <webapp-card
        v-else-if="enterprise && enterprise.DesignByCardsDesktop"
        :enterprise="enterprise"
        :domain="enterprise.Domain"
        :locale="locale"
        :isTotem="true"
      />
      <Webapp
        v-else-if="enterprise"
        :enterprise="enterprise"
      />
      <iframe-totem
        v-else-if="totemActiveMenu && totemActiveMenu.indexOf('ç') === 0"
      />
      <!--Background
        v-else-if="mainEnterprise && mainEnterprise.TotemBackground && mainEnterprise.TotemBackground.length > 0"
        :enterpriseTotemBackground="mainEnterprise.TotemBackground"
        :enterprise="mainEnterprise"
      /-->
      <background-parrilla
        v-else-if="mainEnterprise && mainEnterprise.TotemBackground && mainEnterprise.TotemBackground.length > 0"
        :parrilla="mainEnterprise.TotemBackground"
      />
    </div>
    <TotemMainMenu
      v-if="isInverted"
      :enterprise="mainEnterprise"
      :locale="locale"
      :isInverted="true"
      :noShadow="mainEnterprise ? mainEnterprise.TotemNoShadow : false"
    />
    <parrilla
      v-if="fullScreen && mainEnterprise && isInverted"
      :parrilla="mainEnterprise.Parrilla"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import axios from 'axios'
import api from '@/services/api'
import utils from '@/services/utils'
import TotemMainMenu from './totemMainMenu/Index'
import Background from './Background'
import BackgroundParrilla from './BackgroundParrilla'
import Webapp from './webapp/Index'
import WebappCard from '../desktop/desktopCards/Index'
import Activity from './Activity'
import Aena from './Aena'
import Meteo from './Meteo'
import ItemImage from './ItemImage'
import ItemImageTranslate from './ItemImageTranslate'
import ItemPdf from './ItemPdf'
import HeaderBar from './totemHeader/HeaderBar'
import Parrilla from './totemHeader/Parrilla'
import Messages from './Messages'
import ScreenSaver from './screenSaver/Index'
import ActivityCollege from './activityCollege/Index'
import ActivityBarcelo from './activityBarcelo/Index'
import IframeTotem from './iframeTotem/Index'
import InteractiveMap from './interactiveMap/Index'
import AirportPraia from './AirportPraia'
export default {
  components: {
    ScreenSaver,
    InteractiveMap,
    IframeTotem,
    Messages,
    HeaderBar,
    //TotemHeader,
    TotemMainMenu,
    Webapp,
    WebappCard,
    Background,
    Activity,
    Aena,
    Meteo,
    ItemImage,
    ItemImageTranslate,
    ItemPdf,
    Parrilla,
    BackgroundParrilla,
    ActivityCollege,
    ActivityBarcelo,
    AirportPraia,
  },
  data: () => ({
    mainEnterprise: null,
    enterprise: null,
    bgColor: 'green',
    isInverted: false,
  }),
  computed: {
    ...mapState('app',['totemActiveMenu', 'totemDomain', 'locale']),
    queryIsInverted () {
      return this.$route.query.isInverted === 'true' ? true : false
    },
    urlDomain () {
      return utils.getDomain()
    },
    zoomValue () {
      let zoom =  this.$route.query.zoom
      zoom = zoom && zoom.length > 0 ? `${zoom}% !important` : null
      return zoom
    },
    fullScreen () {
      return utils.isTotem() || this.$route.query.fullscreen === 'true' || this.$route.query.fullScreen === 'true' ? true : false
    },
    queryBGColor () {
      return this.$route.query.color ? `#${this.$route.query.color}` : null
    },
    isDev () {
      return false
      return process.env.VUE_APP_ENV === 'development' || this.$route.query.test
    },
    noShadow () {
      return false
    },
  },
  watch: {
    'totemDomain' (v) {
      this.handleGetEnterpriseData(v)
    },
  },
  mounted () {
    this.handleGetMainEnterprise()
  },
  methods: {
    async handleGetMainEnterprise () {
      let config = await new Promise((resolve, reject) => api.getItem('enterprises', false, `totem-config/${this.urlDomain}`).then(response => {

        this.$store.state.app.totemLMD = response && response.TotemLMD ? new Date(response.TotemLMD) : null
        const isInverted = response && response.TotemForceIsInverted ? true : false
        this.$store.state.app.totemIsInverted = response && response.TotemForceIsInverted ? true : false
        this.isInverted = this.queryIsInverted ? this.queryIsInverted : isInverted

        resolve ({
          totemBackground: response ? response.TotemBackground : null,
          logo: response ? response.TotemLogo : null,
          totemParrilla: response ? response.TotemParrilla : null,
          totemMessage: response ? response.TotemMessage : null,
          totemCustomURLInfo: response && response.TotemCustomURLInfo ? JSON.parse(response.TotemCustomURLInfo) : null,
          totemMainMenuType: response && response.TotemMainMenuType ? response.TotemMainMenuType : 'right',
          totemNoShadow: response && response.TotemNoShadow ? true : false,
          menus: response && response.Config ? JSON.parse(response.Config) : null,
        })
      }))

      if (config && config.menus) {
        config.menus = config.menus.map(item => {
          if (typeof item.image === 'string') {
            if (item.image.indexOf('{') === -1) {
              item.image = { 
                es: item.image,
                en: item.image,
                de: item.image,
                it: item.image,
                fr: item.image
              }
            } else {
              item.image = JSON.parse(item.image)
            }
          }
          if (item.image && !item.image.en && item.image.es) item.image.en = item.image.es
          return item
        })
      }

      api.getItem('enterprises', false, this.urlDomain).then(response => {
        if (this.isDev) response.Font = 'Roboto'
        response.Logo = config.logo
        response.Parrilla = config.totemParrilla
        response.TotemBackground = config.totemBackground
        response.TotemMessage = config.totemMessage
        response.TotemCustomURLInfo = config.totemCustomURLInfo
        response.TotemMainMenuType = config.totemMainMenuType ? config.totemMainMenuType : 'right'
        response.TotemNoShadow = config.totemNoShadow
        response.DesignByCardsDesktop = response.DesignByCards && response.DesignByCardsDesktop ? true : false
        response.Menus = config.menus
        this.mainEnterprise = response
      })
    },
    handleGetEnterpriseData (v) {
      if (!v) this.enterprise = null
      else
        api.getItem('enterprises', false, v).then(response => {
          this.enterprise = response
          if (response.TimeZone) this.$store.state.app.TimeZone = response.TimeZone

          this.$store.state.app.totemMeteoID = response.MeteoID
          this.$store.state.app.Languages = response.Languages.split(',')
          this.$store.state.app.DefaultLocale = response.DefaultLocale ? response.DefaultLocale : 'es'
          this.$store.state.app.authType = response.AuthType && response.AuthType.length > 0 ? response.AuthType : 'none'

          this.prepareConfig(response)
        })
    },
    prepareConfig (response) {
      this.$store.state.app.dtouchWorkspace = response.ID
      this.$store.state.app.enterpriseName = response.Name
      this.$store.state.app.allergenFilters = response.AllergenFilters
      this.$store.state.app.showDishesImage = response.ShowDishesImage
      this.$store.state.app.showDishesAllergens = response.ShowDishesAllergens
      this.$store.state.app.BGColor = response.BGColor ? response.BGColor : '#56A099'
      this.$store.state.app.btnBackgroundColor = response.BtnBackgroundColor ? response.BtnBackgroundColor : ''
      this.$store.state.app.btnTextColor = response.BtnTextColor ? response.BtnTextColor : ''
      this.$store.state.app.foodDrinkTextColor = response.FoodDrinkTextColor ? response.FoodDrinkTextColor : ''
      this.$store.state.app.foodDrinkBGColor = response.FoodDrinkBGColor ? response.FoodDrinkBGColor : ''
      this.$store.state.app.foodIconRight = response.FoodIconRight

      this.$store.state.app.BGColorSecundary = response.BGColorSecundary ? response.BGColorSecundary : '#CCCCCC'
      this.$store.state.app.BGColorContent = response.BGColorContent  ? response.BGColorContent : '#FFFFFF'
      this.$store.state.app.Color = response.Color ? response.Color : '#495057'
      this.$store.state.app.ColorSecundary = response.ColorSecundary ? response.ColorSecundary : '#495057'
      this.$store.state.app.ColorContent = response.ColorContent ? response.ColorContent : '#495057'
      this.logo = response.Logo ? response.Logo : 'http://dtouch.es/assets/72c0948f-7eef-4d82-ab84-f94862c7a37f/e11a8bf0-5c3b-11e9-b777-8fe58a86ecf4.png';
      this.$store.state.app.Logo = response.Logo ? response.Logo : 'http://dtouch.es/assets/72c0948f-7eef-4d82-ab84-f94862c7a37f/e11a8bf0-5c3b-11e9-b777-8fe58a86ecf4.png'
      this.$store.state.app.Carousel = response.Carousel ? response.Carousel.split(',') : []
      this.$store.state.app.withGradient = response.GradientMenu  === 1 ? true : false
      this.$store.state.app.withGradientSubmenu = response.GradientSubmenu === 1 ? true : false
      this.$store.state.app.withLine = response.LineMenu === 1 ? true : false

      this.$store.state.app.GlobalFont = response.GlobalFont
      if (response.Font) this.$store.state.app.Font = response.Font
      if (response.FontSecundary) this.$store.state.app.FontSecundary = response.FontSecundary
      if (response.FontContent) this.$store.state.app.FontContent = response.FontContent

      if (response.FontSize) this.$store.state.app.FontSize = response.FontSize
      if (response.FontSizeSecundary) this.$store.state.app.FontSizeSecundary = response.FontSizeSecundary
      if (response.FontSizeContent) this.$store.state.app.FontSizeContent = response.FontSizeContent

      if (response.TextFormat) this.$store.state.app.TextFormat = response.TextFormat
      if (response.TextFormatSecundary) this.$store.state.app.TextFormatSecundary = response.TextFormatSecundary
    },
  },
}
</script>
<style >
.v-application {
  background: none !important;
}
.totem {
  height: calc(100vh);
}
.totem-body {
  height: 980px;
}
</style>
